// DEVELOPED BY TAHA HUSSAIN
import { BadInput } from './app-error-handler/bad-input';
import { NotFoundError } from './app-error-handler/not-found-error';
import { AppError } from './app-error-handler/app-error';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { tap } from 'rxjs/operators/tap';
import { AppConfig } from './config/app.config';

const HttpFormDataOptions = {
  // 'Content-Type': 'application/x-www-form-urlencoded',
  headers: new HttpHeaders({
    // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    // Authorization:
  }),
};

// 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
// 'Accept': '*/*',
// 'Accept-Language': 'en-US,en;q=0.9,tr;q=0.8',
// 'Access-Control-Allow-Origin': '*',
// "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
// "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization"

@Injectable({
  providedIn: "root",
})
export class DataService {
  private url: string;
  private baseUrl: string;
  private authUrl: string;
  private backendWebUrl: string;
  constructor(appConfig:AppConfig, private http: HttpClient) { 
    this.url = appConfig.backendUrl;
    this.baseUrl = appConfig.baseUrl;
    this.authUrl = appConfig.authUrl;
    this.backendWebUrl = appConfig.backendUrl;
  }

  postDataWithParam(body) {
    // var body =
    // `username=`+params.email+`&`+
    // `password=`+params.password+`&` +
    // `grant_type=password&` +
    // `client_id=AngularJSAppFinanceDev&`+
    // `client_secret=AngularJSsecret`;

    return this.http
      .post(this.authUrl, body)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
  }

  // putDataWithParam(body) {

  //   return this.http.put(this.authUrl, body)
  //     .pipe(map((response: any) => response))
  //     .pipe(catchError(this.handleError))
  // }

  putDataWithParamAuth(action:string,resource:any) {
    return this.http.put(this.baseUrl+action, resource)
    .pipe(map((response: any) => response))
    .pipe(catchError(this.handleError))
}

putByActionAuth(action:string,resource:any) {
  return this.http.put(this.baseUrl+action, resource)
  .pipe(map((response: any) => response))
  .pipe(catchError(this.handleError))
}

  getDataByParam(entity: string, state: any): Observable<GridDataResult> {
    
    var queryStr = `${toDataSourceRequestString(state)}`;
   /// queryStr="page=2&pageSize=10&filter=(RequestType~eq~'Corporate%20Registration%20Request'~and~RequestStatus~eq~'New'~or~RequestStatus~eq~'Rejected')&sort=CreatedDate-desc";
    console.log(queryStr);
    
    // const queryStr = this.stateConvertToQueryString(state);
    // if(entity == "CustomerMaster")
    // {
    //   return this.http
    //     .get(`${this.backendWebUrl}${entity}?${queryStr}`)
    //     .pipe(
    //     map(response => (<GridDataResult>{
    //       data:  response['Data'],
    //       total: response['Total'],
    //       errors: response['Errors'],
    //       aggregateResults: response['AggregateResults'],
    //     })),
    //     tap((ex) => {
    //       // console.log(ex);        
    //     }
    //     )
    //     );
    // }
    // else
    // {
    //  console.log("query string: ", state)
      return this.http
        .get(`${this.url}${entity}?${queryStr}`)
        .pipe(
        map(response => (<GridDataResult>{
          data:  response['Data'],
          total: response['Total'],
          errors: response['Errors'],
          aggregateResults: response['AggregateResults'],
        })),
        tap((ex) => {
          // console.log(ex);        
        }
        )
        );
    // }
  }

  stateConvertToQueryString(state) {
    if (state.skip > 0) {
      return (
        "take=" +
        state.take +
        "&page=" +
        (state.skip / state.take + 1) +
        "&skip=" +
        state.skip +
        "&pageSize=" +
        state.take
      );
    } else {
      return (
        "take=" +
        state.take +
        "&page=1&skip=" +
        state.skip +
        "&pageSize=" +
        state.take
      );
    }
  }
  postDataByParam(entity: string, state: any, argument : any): Observable<GridDataResult> {
    const queryStr = `${toDataSourceRequestString(state)}`;
      console.log("query string: ", state)
      return this.http
        .put(this.url + entity + '?' + queryStr, argument)
        .pipe(
        map(response => (<GridDataResult>{
          data:  response['Data'],
          total: response['Total'],
          errors: response['Errors'],
          aggregateResults: response['AggregateResults'],
        })),
        tap((ex) => {
        }
        )
        );
  }
  getAll() {
    return this.http
      .get(this.url)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
    // .map(response => response.json())
    // .catch(this.handleError);
  }

  getByAction(action: string) {
    return this.http
      .get(this.url + action)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
  }

  getByWebAction(action: string) {
    return this.http
      .get(this.backendWebUrl + action)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
  }

  postByAction(action: string, resource: any) {
    return this.http
      .post(this.url + action, resource)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
  }

  postByWebAction(action:string,resource:any) {
    return this.http.post(this.backendWebUrl+action, resource)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError))
  }

  putByAction(action:string,resource:any) {
    return this.http.put(this.url+action, resource)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
  }
  putByActionPDF(action:string,resource:any) {
    return this.http.put(this.url+action, resource,{responseType:'arraybuffer'})
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
  }

  putByWebAction(action: string, resource: any) {
    return this.http
      .put(this.backendWebUrl + action, resource)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
  }

  create(resource) {
    return this.http
      .post(this.url, JSON.stringify(resource))
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
    // .map(response => response.json())
    // .catch(this.handleError);
  }

  update(resource) {
    return this.http
      .patch(this.url + "/" + resource.id, JSON.stringify({ isRead: true }))
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
    // .map(response => response.json())
    // .catch(this.handleError);
  }

  delete(id) {
    return this.http
      .delete(this.url + "/" + id)
      .pipe(map((response: any) => response))
      .pipe(catchError(this.handleError));
    // .map(response => response.json())
    // .catch(this.handleError);
  }

  private handleError(error: Response) {
    if (error.status === 400)
      return Observable.throw(new BadInput(error.json()));

    if (error.status === 404) return Observable.throw(new NotFoundError());

    return Observable.throw(new AppError(error));
  }
}
